import React, { useEffect , useContexte} from "react";
import './LogIn.css'
import axiosInstance from '../../Axios.js'
import {Link } from 'react-router-dom'

import BMBFLogo from '../../img/BMBF_Logo.svg.png';
import EUFundedLogo from '../../img/DE_Finanziert_von_der_Europäischen_Union__POS.jpg';





export default function LogIn() {


    let domain = window.location.hostname;
    let api = '/api'

    let url_prod = 'https://' + domain + api
  
    let url_dev = 'http://' + domain +':5000' 


  
  


     const handleLogInGitHub = (event) => {

      //console.log('github')
      axiosInstance.post('/caosdb_login_github/',
                       {
                  headers:{  
                    "Access-Control-Allow-Headers": "*",
                    "Access-Control-Allow-Origin": "*",
                    "Access-Control-Allow-Credentials": "true",
                    "Content-Type": "application/json",}, 
                      
                }
              ).then((response)  => {
               // console.log(response.data['info'])
                window.location.href = response.data['info']
              })
              
              .catch((error) => {//console.log(error)
                                
            
            })
                 
            
      


     }


     const handleLogInGoogle = (event) => {


      axiosInstance.post('/caosdb_login_google/',
                       {
                  headers:{  
                    "Access-Control-Allow-Headers": "*",
                    "Access-Control-Allow-Origin": "*",
                    "Access-Control-Allow-Credentials": "true",
                    "Content-Type": "application/json",}, 
                      
                }
              ).then((response)  => {
               
                //console.log(response.data['info'])
                window.location.href = response.data['info']
              })
              
              .catch((error) => {//console.log(error)
                                
            
            })
                 
            
      

      
     }

     const handleLogInOpenConnect = (event) => {


      axiosInstance.post('/caosdb_login_openconnect/',
                       {
                  headers:{  
                    "Access-Control-Allow-Headers": "*",
                    "Access-Control-Allow-Origin": "*",
                    "Access-Control-Allow-Credentials": "true",
                    "Content-Type": "application/json",}, 
                      
                }
              ).then((response)  => {
                
                //console.log(response.data['info'])
                window.location.href = response.data['info']
              })
              
              .catch((error) => {//console.log(error)
                                
            
            })
                 
            
      

    

     }


     
     


    return(
      <div className="login-wrapper">
      <div className="login">
        <h2>Welcome to the Tmatrix Portal</h2>
        <p>
          This platform is part of the <strong>Daphona project</strong>, focused on enhancing data competencies 
          for the next generation of researchers. It is funded by the German Federal Ministry of Research, Technology and Space (BMFTR) and the European Union.
        </p>
    
        <div className="logo-row">
          <img src={BMBFLogo} alt="BMBF" />
          <img src={EUFundedLogo} alt="EU Funded" />
        </div>
    
        <h4>Sign in using your institutional account (or Github, Google, ORCID)</h4>
        <input
          type="button"
          value="Sign In"
          className="btn"
          onClick={handleLogInOpenConnect}
        />
    
        <nav>
          <Link to="https://..." target="_blank" rel="noopener noreferrer">About</Link>
          <Link to={`${url_prod}/PrivacyPolicy/`} target="_blank" rel="noopener noreferrer">Privacy policy</Link>
          <Link to="mailto:tmatrix-portal-admin-request@lists.kit.edu">Contact</Link>
        </nav>
      </div>

      <footer className="footer">
          <p>© 2023 Tmatrix – Daphona Project · Funded by BMBF and EU</p>
        </footer>
      </div>
    
          
    )




}
